import type { TOC } from '@ember/component/template-only';
import GeneralDayDetailDayDetail from 'lumen/components/general/day-detail/day-detail';
import type HotelPricingManagerDetailController from 'lumen/controllers/hotel/pricing-manager/detail';

interface HotelPricingManagerDetailSignature {
  Args: {
    controller: HotelPricingManagerDetailController;
    model: unknown;
  };
}

<template>
  <GeneralDayDetailDayDetail
    @activeCompset={{@controller.hotelAndMarketService.activeCompset}}
    @changeDay={{@controller.changeDay}}
    @currentHotel={{@controller.hotel}}
    {{! @glint-expect-error: Incorrect type }}
    @date={{@controller.date}}
    @edit={{@controller.edit}}
    @hasOtbSelfServiceEntryPoint={{true}}
    @isBestFlex={{@controller.isBestFlex}}
    @isPricingAssistantProduct={{@controller.isPricingAssistantProduct}}
    {{! @glint-expect-error: Incorrect type }}
    @isRedirected={{true}}
    @model={{@controller.model}}
    @offset={{@controller.offset}}
    @onToggleEdit={{@controller.onToggleEdit}}
    @otaId={{@controller.otaId}}
    @ratesParams={{@controller.ratesParams}}
    @redirect={{@controller.redirect}}
    @selectedOTA={{@controller.selectedOTA}}
    @type={{@controller.type}}
    @updateOffset={{@controller.updateOffset}}
    @updateType={{@controller.updateType}}
  />
</template> satisfies TOC<HotelPricingManagerDetailSignature>;
